@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<div class="flex-col w-100 justify-stretch items-stretch bidding-history">
  <div class="w-100">
    @if (propertyBidHistory?.auctionBidHistories?.length) {
      <mat-tab-group class="w-100">
        @for (abh of propertyBidHistory.auctionBidHistories; track abh; let i = $index) {
          <mat-tab class="w-100" [label]="'Auction ' + abh.scheduleSeqNo + abh.voidInfo + ': ' + abh.auctionBids?.length + ' bid(s)'">
            <!-- phones: scrolls horizontally, user name column stays visible (see theme/styles/_table-stack.scss) -->
            <div class="table-scroll-sm">
              <table mat-table [dataSource]="dataSourceArray[i]" class="w-100 bidding-history">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef><strong class="text-sm">Name</strong></th>
                  <td mat-cell *matCellDef="let auctionBid">{{auctionBid.firstName}} {{auctionBid.lastName}}</td>
                </ng-container>
                <ng-container matColumnDef="userName" sticky>
                  <th mat-header-cell *matHeaderCellDef> <strong class="text-sm">User name</strong> </th>
                  <td mat-cell *matCellDef="let auctionBid">{{auctionBid.userName}}</td>
                </ng-container>
                <ng-container matColumnDef="role">
                  <th mat-header-cell *matHeaderCellDef><strong class="text-sm">Role</strong> </th>
                  <td mat-cell *matCellDef="let auctionBid">{{auctionBid.role}}</td>
                </ng-container>
                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef >Bid</th>
                  <td mat-cell *matCellDef="let auctionBid"> {{auctionBid.currentBid | currency : 'USD' : 'symbol' : '1.2-2'}} </td>
                </ng-container>
                <ng-container matColumnDef="time">
                  <th mat-header-cell *matHeaderCellDef >Bid Time</th>
                  <td mat-cell *matCellDef="let auctionBid"> {{auctionBid.bidDateTime | date:'medium' }} </td>
                </ng-container>
                @if (auctionType()==1) {
                  <ng-container matColumnDef="autobid" >
                    <th mat-header-cell *matHeaderCellDef >Proxy</th>
                    <td mat-cell *matCellDef="let auctionBid"><a mat-button (click)="onBidderInformation(auctionBid)"><mat-icon class="primary-color">@if(auctionBid.historicProxyAction=='INC'){arrow_upward}@else if(auctionBid.historicProxyAction=='DEC'){arrow_downward}@else if(auctionBid.historicProxyAction=='EQU'){block}</mat-icon>{{auctionBid.historicProxyAmount | currency : 'USD' : 'symbol' : '1.2-2'}}</a></td>
                  </ng-container>
                  <ng-container matColumnDef="equalized" >
                    <th mat-header-cell *matHeaderCellDef >Equalized</th>
                    <td mat-cell *matCellDef="let auctionBid" matTooltipClass="tooltip-linebreak" [matTooltip]="auctionBid.equalizedReasonTooltip">{{auctionBid.equalizedIndicator}}</td>
                  </ng-container>
                  <ng-container matColumnDef="void" >
                    <th mat-header-cell *matHeaderCellDef >Void</th>
                    <td mat-cell *matCellDef="let auctionBid" matTooltipClass="tooltip-linebreak" [matTooltip]="auctionBid.equalizedReasonTooltip">{{auctionBid.equalizedIndicator}}</td>
                  </ng-container>
                }
                @else if (auctionType()==2) {
                  <ng-container matColumnDef="bidAccepted" >
                    <th mat-header-cell *matHeaderCellDef >Bid Accepted</th>
                    <td mat-cell *matCellDef="let auctionBid">@if (auctionBid.bidAccepted) {
                      <span>Yes</span>
                      }@else {
                      <span>No</span>
                    }</td>
                  </ng-container>
                  <ng-container matColumnDef="askAmount" >
                    <th mat-header-cell *matHeaderCellDef >Ask</th>
                    <td mat-cell *matCellDef="let auctionBid">{{auctionBid.askAmount | currency : 'USD' : 'symbol' : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="askAmountExclusivitySeconds" >
                    <th mat-header-cell *matHeaderCellDef >Exclusivity Seconds</th>
                    <td mat-cell *matCellDef="let auctionBid">{{auctionBid.askAmountExclusivitySeconds}} </td>
                  </ng-container>
                  <ng-container matColumnDef="askAccepted" >
                    <th mat-header-cell *matHeaderCellDef >Ask Accepted</th>
                    <td mat-cell *matCellDef="let auctionBid">@if (auctionBid.askAccepted) {
                      <span>Yes</span>
                      }@else {
                      <span>No</span>
                    }</td>
                  </ng-container>
                }
                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let auctionBid">
                    <button mat-icon-button class="primary-color" color="primary" (click)="onBidderInformation(auctionBid)" matTooltip="Bidder Information">
                      <mat-icon>person</mat-icon>
                    </button>
                    @if (auctionBid.representingBrokerId) {
                      <button mat-icon-button class="primary-color" color="primary" (click)="onBidderInformation(auctionBid)" matTooltip="Represented by Broker">
                        <mat-icon>people_outline</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let bid; columns: displayedColumns;"></tr>
              </table>
            </div>
            <mat-divider class="w-100"></mat-divider>
          </mat-tab>
        }
      </mat-tab-group>
    }
    @else {
      <div class="text-center">No bidding history data available.</div>
    }
  </div>
</div>

